import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { isHydrateAction } from './hydration';
import { persistKey } from '@store/index';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  refetchOnMountOrArgChange: true,
  extractRehydrationInfo(action, { reducerPath }): any {
    try {
      if (isHydrateAction(action)) {
        if (
          action.key === persistKey &&
          action.payload &&
          action.payload[reducerPath]
        ) {
          return action.payload[reducerPath];
        }
      }
    } catch (error) {
      console.error('Error extracting rehydration info:', error);
    }
    return undefined;
  },
  tagTypes: [
    // FO
    'Bookings',
    'Specific Booking',
    'Group Bookings',
    'CancelledBookings',
    'Pending Bookings',
    'Booking Room Rates',
    'DeclareNewDay',
    'Sales Date',
    'Account Masterlist',
    'Booking Option List',
    'Nationality List',
    'Room Blockings',
    'Booking Sharer',
    'Cash Breakdown',

    // ROOM POSTING
    'RoomPosting',
    'Ledger',
    'GuestLedger',

    // Masterlist
    'Profile',
  ],
  endpoints: () => ({}),
});
